export const GET_IAAC_LICENSE_REQUEST = "get_iaac_license_request";
export const GET_IAAC_LICENSE_SUCCESSFUL = "get_iaac_license_successful";
export const GET_IAAC_LICENSE_FAILED = "get_iaac_license_failed";
export const CLEAR_ALL_IAAC_LICENSE_MESSAGES = "clear_all_iaac_license_messages";
export const CLEAR_ALL_IAAC_LICENSE_MESSAGES_SUCCESSFUL = "clear_all_iaac_license_messages_successful";
